import axios from "axios";

axios.defaults.baseURL = '/wuxi/dsbi'

export const apiGet = (url, params) => {
  return axios.get(url, { params })
}

export const apiPost = (url, params) => {
  return axios.post(url, { params })
}